import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children, requireSubscription = false, requireConsent = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBF9F6]">
        <div className="animate-pulse text-stone-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if consent is required but not yet accepted
  if (requireConsent && !user.consent_accepted) {
    return <Navigate to="/consent" replace />;
  }

  if (requireSubscription && !['active', 'trialing'].includes(user.subscription_status)) {
    return <Navigate to="/checkout" replace />;
  }

  return children;
};
